import React from 'react';
import { 
    Input,
    List,
    Popconfirm,
    Spin,
    Popover,
    Row,
    Button,
    Radio,
    message
} from 'antd';

import {
    
    _getSuppliersDetails,

    _postQbFindSuppliers,
    _postQbSetSellerId,
    _postQbCreateSupplier

} from '../../services'

import InfiniteScroll from 'react-infinite-scroller'

import debounce from 'debounce'

const { Search } = Input

const RadioGroup = Radio.Group
    
class QuickbooksUserSearch extends React.Component{

    render(){
        return(
            <div>
                <Search
                    placeholder="Search supplier name"
                    onChange={this.handleOnSearchChange}
                    onSearch={this.handleSearch}
                    style={{width:200, marginBottom:8}}
                    />
                <div  
                    style={{
                            textAlign:'center',
                            border: "1px solid #e8e8e8",
                            borderRadius: 4,
                            padding: "8px 24px",
                            height:400,
                            overflow:"auto",
                            marginBottom:16
                        }}>
                    <InfiniteScroll
                            initialLoad={false}
                            loadMore={this.handleInfiniteOnLoad}
                            hasMore={!this.state.loading && this.state.hasMore}
                            useWindow={false}
                            >
                            <List
                                dataSource={this.state.data}
                                renderItem={item => (
                                    <Popconfirm
                                    title={<div>
                                        <span>
                                        Link <b>{item.DisplayName}</b> to <br/> <b>{this.props.supplierDetails.companyName}</b>?
                                        </span>
                                        <br/>
                                        <span>This cannot be undone.</span>
                                        </div>}
                                    onConfirm={()=>this.handleSetQuickbooksId(item.Id, item.DisplayName) }
                                    okText="Yes" 
                                    cancelText="No">
                                    <List.Item  
                                        style={{cursor: "pointer"}}
                                        key={item.Id}>
                                        <div style={{textAlign:"left"}}>{item.DisplayName}</div>
                                    </List.Item>
                                    </Popconfirm>
                                )}
                            >
                                {(this.state.loading && this.state.hasMore)?
                                <div>
                                    <Spin />
                                </div>
                                :
                                null    
                                }
                            </List>
                    </InfiniteScroll>
                </div>
                {this.renderQuickbooksSellerButton()}
            </div>
        )
    }

    constructor(props){
        super(props);
        
        this.state = {
            data:[],
            loading:true,
            hasMore:true,
            page:0,
            searchTerm:'',
            qbSellerNameType:'companyName',
            createSupplierLoading:false
        }

        this.handleSearch = debounce(this.handleSearch, 200);


    }

    componentWillMount(){
        
        _postQbFindSuppliers(this.state.page, this.state.searchTerm)
        .then( res => this.setState({data:res.data.suppliers, loading:false}))
        .catch( err => console.log(err))

    }

    handleConfirmCreateQuickbooksSupplier = (supplierId, qbSellerName) =>{

        console.log(supplierId, qbSellerName)
        
        this.setState({createSupplierLoading:true})

		_postQbCreateSupplier(supplierId, qbSellerName)
		.then(res =>{

            const { seller } = res.data.quickbooks
        
            this.setState({createSupplierLoading:false})
            
            message.success(`Successfully created ${seller.displayName}`)

            this.handleSetQuickbooksId(seller.id, seller.displayName)

        })
        .catch( err => message.error("Error creating quickbooks seller!"))
		
		
	}

    handleOnChangeSellerNameType = (e) =>{

		this.setState({qbSellerNameType:e.target.value})

	}

    handleOnSearchChange = (e) => {

        if(!e){
            return
        } else {
            this.handleSearch(e.target.value)
        }
    }

    handleInfiniteOnLoad = () => {

        let { data, page, searchTerm } = this.state
    
        page += 1

        this.setState({
          loading: true,
          page
        }, () => {
            _postQbFindSuppliers(this.state.page, searchTerm)
            .then(res => {
    
                if(res.data.suppliers.length === 0){
                    message.warning("Loaded all suppliers")
                    this.setState({
                        hasMore:false,
                        loading:false
                    })
                } else {
                    
                    data = data.concat(res.data.suppliers)
                    this.setState({
                        data,
                        loading:false
                    })
                }
    
            })
        })

      }

    handleSearch = (value)=>{

        this.setState({
            page: 0,
            searchTerm: value,
            loading:true,
            hasMore:true
        }, ()=>{
            _postQbFindSuppliers(this.state.page, this.state.searchTerm)
            .then( res => {
                if(res.data.suppliers.length === 0){
                    message.warning("No suppliers found!")
                }

                this.setState({
                    data: res.data.suppliers, 
                    loading:false
                })
            })
        })
    }

      handleSetQuickbooksId=(quickbooksId, quickbooksDisplayName)=>{

        _postQbSetSellerId({
            quickbooksId, 
            quickbooksDisplayName, 
            supplierId:this.props.supplierDetails.supplierId
        })
        .then( res => {

            message.success(`Successfully set ${quickbooksDisplayName}`)

            this.props.onClickDone();

        })
    }

    renderQuickbooksSellerButton = () => {

        const { supplierDetails } = this.props;

		const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
          };


		let qbSellerName;

		switch(this.state.qbSellerNameType){
			case "companyName":
				qbSellerName = supplierDetails.companyName
				break;
			case "name":
				qbSellerName = supplierDetails.name
				break;
			case "email":
				qbSellerName = supplierDetails.email
                break;
            default:
                break;
		}

		return(
			<Popover 
			trigger="click"
			title={<Row type="flex" justify="center">Use {qbSellerName} for Quickbooks</Row>}
			style={{width:250}}
			content={(
				<Row>
					<Row>
					<RadioGroup onChange={this.handleOnChangeSellerNameType} value={this.state.qbSellerNameType}>
						<Radio style={radioStyle} value={"companyName"}>Company Name</Radio>
						<Radio style={radioStyle} value={"name"}>Buyer Name</Radio>
						<Radio style={radioStyle} value={"email"}>Email</Radio>
					</RadioGroup>
					</Row>
					<Row type="flex" justify="center">
						<Button type="primary" onClick={()=>this.handleConfirmCreateQuickbooksSupplier(supplierDetails.supplierId, qbSellerName)}>Confirm</Button>
					</Row>
				</Row>
			)}
			>
            <Row type="flex" justify="center">
                {this.state.createSupplierLoading?
                <Spin/>
                :
				<Button>Create Quickbooks Seller</Button>
                }
            </Row>
            </Popover>
		)
    }


}

export default QuickbooksUserSearch;


// WEBPACK FOOTER //
// ./src/components/orders-v3/quickbooks-user-search.js